import { useState } from "react";

interface JsonBlockProps {
	label: string;
	value: unknown;
}

/** Collapsed by default: raw model output is evidence for a reviewer, not the summary. */
export const JsonBlock = ({ label, value }: JsonBlockProps) => {
	const [open, setOpen] = useState(false);
	const text =
		typeof value === "string" ? value : JSON.stringify(value, null, 2);
	return (
		<div className="border-secondary rounded-md border">
			<button
				aria-expanded={open}
				className="text-secondary w-full px-3 py-2 text-left text-sm"
				onClick={() => setOpen((v) => !v)}
				type="button"
			>
				{open ? "▾" : "▸"} {label}
			</button>
			{open && (
				<pre className="text-primary overflow-x-auto px-3 pb-3 text-xs">
					{text}
				</pre>
			)}
		</div>
	);
};
